<app-modal-basic #productsModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">Modal title</h4>
    <button type="button" class="close basic-close" (click)="productsModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <h5>Large Modal</h5>
    <p>This is Photoshop's version of Lorem IpThis is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-default ripple" (click)="productsModal.hide()">Close</button>
    <button type="button" class="btn btn-primary ripple light">Save changes</button>
  </div>
</app-modal-basic>
